class PaymentAccountPermission
{
    // Admin privileges, other permissions are not checked
    static ROOT = 'payment_account.*';

    // Enabled flag: if not present, access denied on any operation. Not required for root
    static _ENABLED = 'payment_account._m';

    // Initiate payment account sync
    static SYNC = 'payment_account.sync';

    // Can access archived payment accounts
    static ACCESS_ARCHIVE = 'payment_account.access.archive';
}

export default PaymentAccountPermission;
